import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import Avatar from "../assets/icons/profile-user.svg";
import { RightOverlayProps } from "../../constants/CoreConsts";

export class Nav extends Component {
  render() {
    const { handleProfileSidebar, match, User, userprofileState, pages, _ } =
      this.props;

    const getMenu = (title, page, index) => {
      if (title === "Notifications")
        return (
          <a
            className={
              this.props.notificationsState
                ? "has-count navLinks navLink-open"
                : "has-count navLinks"
            }
            href={DummyLink}
            onClick={this.props.handleNotifications}
          >
            {this.props.notificationNum && this.props.notificationNum > 0 ? (
              <span
                className={
                  this.props.noteBounceAnim ? "count bounceAnim" : "count"
                }
              >
                {this.props.notificationNum}
              </span>
            ) : null}
            <i className="icon-omni-notification-null-nav" />
          </a>
        );
      else if (title === "ContactUs")
        return (
          <a
            href={DummyLink}
            onClick={this.props.handleProfileFeedback}
            className={
              this.props.feedbackState
                ? "has-count navLinks navLink-open"
                : "has-count navLinks"
            }
          >
            <i className="icon-omni-contact-us" />
          </a>
        );
      else return <PageLink {...{ page, match, _, index }} />;
    };

    const DummyLink = "#";

    return (
      <>
        {pages.map(({ condition, title, ...page }, index) => {
          return (
            (condition ? condition(User) : true) && (
              <OverlayTrigger
                key={`${title}-page-link`}
                {...RightOverlayProps}
                overlay={
                  <Tooltip className="omni-nav-tooltip">
                    {_.Sidebar[title] || title}
                  </Tooltip>
                }
              >
                {getMenu(title, page, index)}
              </OverlayTrigger>
            )
          );
        })}

        <OverlayTrigger
          {...RightOverlayProps}
          overlay={
            <Tooltip className="omni-nav-tooltip">
              {_.Sidebar.Profile || "Profile"}
            </Tooltip>
          }
        >
          <a
            href={DummyLink}
            className={`has-count end-link navLinks ${
              (userprofileState && "navLink-open") || ""
            } ${(User.uinits && "has-initials") || ""}`}
            onClick={handleProfileSidebar}
          >
            <span className="avatar-holder">
              <img src={Avatar} alt="Avatar" className="avatar" />
              {User.uinits && <span>{User.uinits}</span>}
            </span>
          </a>
        </OverlayTrigger>
      </>
    );
  }
}

function PageLink({ page, match, _, index, ...others }) {
  const { path: to, iconName } = page;

  const className = match.url === to ? "current" : null;
  const hasBorderLine =
    (match.url === "/" && index === 0) || match.url.includes(to);

  return (
    <Link {...{ to, className, ...others }}>
      {hasBorderLine && <div className="borderLine"></div>}
      <i key={iconName} className={`icons ${iconName}`} />
    </Link>
  );
}

export default withRouter(Nav);
